import TableActionButton from '@/components/Buttons/TableActionButton';
import ExportIcon from '@/components/Icons/ExportIcon';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';

interface IProps {
  onImpersonationClick: () => void;
  onViewProfileClick: () => void;
  onRemoveClick: () => void;
  disabled?: boolean;
  editSelfEnabled?: boolean;
}

const UserActions = ({
  onImpersonationClick,
  onViewProfileClick,
  onRemoveClick,
  disabled,
  editSelfEnabled,
}: IProps) => {
  return (
    <div className='flex gap-[8px] justify-center'>
      <TableActionButton
        sx={{ padding: '4px 12px', minWidth: 'auto' }}
        variant='outlined'
        color='primary'
        onClick={onImpersonationClick}
        disabled={disabled}
      >
        <SupervisorAccountIcon />
      </TableActionButton>
      <TableActionButton
        variant='outlined'
        color='primary'
        onClick={onViewProfileClick}
        disabled={disabled && !editSelfEnabled}
      >
        <ExportIcon className='w-[11px] mr-[4px]' />
        <span>Edit</span>
      </TableActionButton>
      <TableActionButton variant='outlined' color='error' onClick={onRemoveClick} disabled={disabled}>
        Remove
      </TableActionButton>
    </div>
  );
};

export default UserActions;
